<template>
  <v-container fluid>
    <v-row dense>
      <!-- ERRORS -->
      <v-col v-if="errors.length" cols="12">
        <v-alert
          v-for="(item, index) in errors"
          :key="index"
          dense
          type="error"
          outlined
          dismissible
          class="mb-2"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>

      <!-- CUSTOMER NAME -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="name"
          label="Customer Name"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- AMOUNT PAID -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model.number="paid"
          label="Amount Paid"
          type="number"
          prefix="₱"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- DATE -->
      <v-col cols="12">
        <v-text-field
          v-model="date"
          label="Date"
          type="date"
          outlined
          dense
          hide-details="auto"
        />
      </v-col>

      <!-- SAVE BUTTON -->
      <v-col cols="12" class="mt-2">
        <v-btn
          color="primary"
          dark
          block
          :loading="storing"
          :disabled="!name || !paid || !date"
          @click="update"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Save Changes
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.v-alert {
  border-radius: 6px;
}

.v-btn {
  letter-spacing: 0.3px;
}
</style>
<script>
import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
import { errorHandler } from '@/extra-functions/store.extra'
export default {
  name: 'EditConsumerLoanTransaction',
  props: {
    propConsumerLoanId: String,
    propConsumerId: String,
    propConsumerLoanTransaction: Object,
  },
  data() {
    return {
      name: null,
      date: null,
      paid: null,
      storing: false,
      errors: [],
    }
  },
  watch: {
    propConsumerLoanTransaction(data) {
      this.name = data.payer_name
      this.date = data.date_transaction
      this.paid = data.amount_paid
    },
  },
  methods: {
    update() {
      if (!this.storing) {
        this.storing = true
        this.errors = []
        const data = {
          consumer_loan_id: this.propConsumerLoanId,
          payer_name: this.name,
          date_transaction: this.date,
          amount_paid: this.paid,
        }
        const id = this.propConsumerLoanTransaction.id
        const params = {
          consumer: this.propConsumerId,
          consumerLoan: this.propConsumerLoanId,
        }
        CLTRepository.update(params, { id, data })
          .then(() => {
            this.$emit('close-dialog')
          })
          .catch((e) => {
            this.errors = errorHandler(e)
          })
          .then(() => {
            this.storing = false
          })
      }
    },
  },
}
</script>
